import { message } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CreateOrEditCustomRule } from '@/comp';
import { permissions } from '@/constants';
import { useStores } from '@/hooks/use-stores';

const RuleCreatePage = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { devicesStore, stationStore, permissionStore } = useStores();

  // check for permission
  useEffect(() => {
    if (!permissionStore.isAuth(permissions.CREATE_CUSTOM_ALERT)) {
      message.error(t('You dont have enough permission to create an alert, please contact your administrator.'));
      navigate('/rules');
    }
  }, []);

  useEffect(() => {
    if (devicesStore.isReady) return;

    devicesStore.getDevicesMetadata();
  }, [stationStore.currentStation.id]);

  return <CreateOrEditCustomRule />;
});

export default RuleCreatePage;
